<template>
  <i style="color: red;" :class="'iconfont ' + name" :style="{ color: color, fontSize: size + 'px', fontWeight: fontWeight }"></i>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    name: {
      type: String as PropType<string>,
      required: true
    },
    color:{
     type: String,
    default:'red'
    },
    fontWeight:{
     type: String,
    default:''
    },
     size:{
     type: Number,
    default:16
  
    }
  }
});
</script>

<style scoped>
.iconfont {
  font-family: 'iconfont';
  margin: 0 5px 0 0;
}

</style>
